// src/hashUtils.js
import CryptoJS from "crypto-js";

export const hashValue = value => {
  return CryptoJS.SHA256(value).toString(CryptoJS.enc.Hex);
};
